module.exports = __webpack_public_path__ + "media/images/vouchers/homme-98eac15bbbd61bf824296f621a4bd306.png";